const AGREEMENT_LOCALES = [
  'de',
  'en-gb',
  'en-us',
  'en',
  'es',
  'fr',
  'it',
  'ja',
  'nl',
  'pt-br',
  'pt-pt',
  'sv',
  'zh-hk',
];

export default AGREEMENT_LOCALES;
